import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { url: String, createNew: Boolean, excludeNew: Boolean }

  connect() {
    const initialValue = this.element.value

    this.select = new TomSelect(this.element, {
      valueField: "id",
      labelField: "text",
      searchField: "text",
      // createNew: ao digitar um nome inexistente, oferece "<nome> (Novo)" com
      // id=-1 (convenção do app p/ "criar nova pessoa" no submit).
      create: this.createNewValue
        ? (input, callback) => callback({ id: "-1", text: input.trim() + " (Novo)" })
        : false,
      loadThrottle: 300,

      load: (query, callback) => {
        if (!query.length) return callback()

        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.set("q", query)

        fetch(url.toString(), { headers: { Accept: "application/json" } })
          .then((r) => r.json())
          .then((json) => callback(this.excludeNewValue
            ? json.data.filter((item) => Number(item.id) > 0)
            : json.data))
          .catch(() => callback())
      }
    })

    this.select.on("change", () => this.notifyChange())

    if (initialValue) {
      this.select.setValue(initialValue, true)
    }
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
      this.select = null
    }
  }

  notifyChange() {
    this.element.dispatchEvent(new Event("change", { bubbles: true }))

    const id = this.element.value
    const option = this.select && id ? this.select.options[id] : null
    this.element.dispatchEvent(new CustomEvent("remote-select:changed", {
      detail: { id, option },
      bubbles: true
    }))
  }

  get tomselect() {
    return this.select
  }

  setValue(value) {
    if (!this.select) return
    this.select.setValue(value, true)
    this.notifyChange()
  }

  selectItem({ id, label }) {
    const strId = String(id)

    let opt = Array.from(this.element.options).find((o) => o.value === strId)
    if (!opt) {
      opt = new Option(label, strId, true, true)
      this.element.add(opt)
    }
    opt.selected = true

    if (this.select) {
      if (!this.select.getOption(strId)) {
        this.select.addOption({ id: strId, text: label })
      }
      this.select.setValue(strId, true)
    }

    this.notifyChange()
  }
}
